import io from 'socket.io-client'
import store from '../store'
import router from '@/router'
import { logout } from '@/utils/user'
import { showNotice } from '@/utils/tool'

export default {
  install(Vue, options) {
    Vue.prototype.$socket = {
      client: null,
      init: function() {
        if (this.client) {
          return
        }
        this.client = io(store.getters.urlInfo.websocketUrl + '&token=' + (store.getters.token ? store.getters.token : ''), {
          // query: {
          //   language: store.getters.language,
          //   token: store.getters.token ? store.getters.token : ''
          // },
          transports: ['websocket'],
          withCredentials: false
        })

        let client = this.client
        const self = this

        // socketio內建event
        // 建立連線
        this.client.on('connect', function() {
          console.log('socket connected ' + client.id)
        })
        // 重新連線
        this.client.on('reconnect', function() {
          console.log('socket reconnect')
        })
        // 斷線重連
        this.client.on('disconnect', function() {
          console.log('socket disconnect')
        })
        // 關閉重連
        this.client.on('close', function(event) {
          console.log('socket close')
        })

        // 自訂event
        // 防多開視窗
        this.client.on('block', function(message) {
          console.log('socket block', message)
          client.close()
          client = null

          showNotice(message, function() {
            self.reinit()
          })
        })

        // 認證失敗 或被踢出
        this.client.on('authFail', function(message) {
          console.log('socket authFail', message)
          logout(message)
        })

        // point更新
        this.client.on('point', function(model) {
          // console.log('socket point', model)
          if (store.getters.token != null) {
            store.commit('SET_GOLD_INFO', model)
          }
        })

        // 站內信
        this.client.on('letterSend', function(model, title) {
          store.commit('SET_UNREAD_LETTER_PLUS')
          store.commit('SET_NEW_LETTER', true)
          showNotice(title + '\r\n' + model.content, () => {
            router.push('/user/letter')
          }, true, true)
        })

        // Roll房中獎
        this.client.on('notifyRollWin', function(model, title) {
          showNotice(title + '\r\n\r\n' + model.content)
        })

        // 遊戲餘額
        this.client.on('gamePoint', function(model) {
          const current = store.getters.gameBalance
          current[model.game_provider_id] = model
          store.commit('SET_GAME_BALANCE_INFO', current)
        })
      },
      reinit: function() {
        console.log('reinit')

        if (this.client) {
          this.client.close()
          this.client = null
        }

        this.init()
      },
      close: function() {
        console.log('close')

        if (this.client) {
          this.client.close()
          this.client = null
        }
      }
    }
  }
}
